import { isInstanceSuperAdmin, isSuperAdmin } from '@lumapps/permissions';
import { createSelector } from '@lumapps/redux/reselect';
import { BackOfficeStore } from '@lumapps/redux/types';
import { isCoveoEnabled } from '@lumapps/search/ducks/selectors';

export const searchSettingsSelector = (state: BackOfficeStore) => state?.searchSettings || {};

export const canAccessSearchSettings = createSelector(
    isCoveoEnabled,
    isSuperAdmin,
    isInstanceSuperAdmin,
    (isCoveo, isGlobalAdmin, isSiteAdmin) => {
        return !isCoveo && (isGlobalAdmin || isSiteAdmin);
    },
);
